// -----------------------------------------------------------------------------
// storage.js: contains localStorage helper functions
// This file is a part of JS client utils
// Copyright (c) JS client utils authors (see file `COPYRIGHT` for the license)
// -----------------------------------------------------------------------------

"use strict";
/**
 * @global
 */
export let storage = {
  available: function() {
    try {
      var x = '__storage_test__';
      window.localStorage.setItem(x, x);
      window.localStorage.removeItem(x);
      return true;
    } catch (e) {
      return false;
    }
  },

  /**
   * @param {String} key saved storage key
   * @param {String} value saved value
   */
  save: function(key, value) {
    window.localStorage.setItem(key, value);
  },

  /**
   * Returns value from storage
   * @param {String} key storage key
   * @param {String} value saved value
   * @returns {String}
   */
  get: function(key) {
    return window.localStorage.getItem(key);
  },

  /**
   * @param {String} key storage key
   */
  remove: function(key) {
    window.localStorage.removeItem(key);
  },

  /**
   */
  clear: function() {
    window.localStorage.clear();
  }
};

